import { createSlice, createAction } from "@reduxjs/toolkit";

export default function getCompaniesReducer(companies = []) {
	const companiesSlice = createSlice({
		name: "companies",
		initialState: companies,
		reducers: {
			refresh: (state, action) => {
				return [...action.payload];
			},
			setCompanies: (state, action) => {
				return [...action.payload];
			},
			removeCompany: (state, { payload }) => {
				const index = state.findIndex(company => company._id === payload._id);
				if (index !== -1) state.splice(index, 1);
			}
		}
	});

	return companiesSlice.reducer;
}

export const refreshCompanies = createAction("companies/refresh");
export const setCompanies = createAction("companies/setCompanies");
export const removeCompany = createAction("companies/removeCompany");
